import React from 'react';
import { Stack, Text } from 'rsuite';
import InfoIcon from './InfoIcon';

const LabelWithInfoIcon = ({
  label,
  infoText,
  isBold = false,
  className = '',
}) => {
  return (
    <Stack
      spacing={10}
      className={className}
    >
      <Stack.Item>
        <Text className={isBold ? 'text-bold' : ''}>{label}</Text>
      </Stack.Item>
      {infoText && (
        <Stack.Item>
          <InfoIcon text={infoText} />
        </Stack.Item>
      )}
    </Stack>
  );
};

export default LabelWithInfoIcon;
